<tilby-dialog-toolbar mat-dialog-title
    [title]="data.title"
    [disabled]="form.invalid"
    (confirm)="confirm()"
/>
<tilby-dialog-content>
  <div class="tw-mb-2 tw-px-2">
    <button type="button" mat-button color="primary" 
        aria-label="Add barcode"    
        class="tw-p-0"
        (click)="addBarcode()">
        <div class="tw-flex tw-items-center">
            <mat-icon class="tw-flex-none">add_circle</mat-icon>
            <span class="tw-ml-2 tw-text-left">{{ 'ITEMS.DETAILS.ADD_BARCODE' | translate }}</span>
        </div>
    </button>
  </div>

  @if(formReady) {
      <form [formGroup]="form">
        <div formArrayName="barcodeList" class="barcode-container">
            @for (group of barcodeList.controls; track group; let i = $index) {
                <div [formGroupName]="i" class="tw-border-0 tw-border-b tw-border-solid tw-border-[var(--sys-divider)] 
                    md:tw-border-0 last:tw-border-0 firts:tw-pt-0 md:tw-pt-0 tw-pt-2">
                    <section class="tw-pt-2 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                        <div class="tw-flex tw-items-baseline tw-col-span-12 md:tw-col-span-9">
                            <!-- Pulsante Elimina -->
                            <button type="button" mat-button 
                                aria-label="Remove variation" 
                                class="tw-min-w-fit tw-mr-2"
                                (click)="removeBarcode(i)"
                            >
                                <div class="tw-flex">
                                    <mat-icon>delete_forever</mat-icon>
                                </div>
                            </button>
            
                            <!-- Campo Testo Barcode -->
                            <mat-form-field class="tw-w-full">
                                <mat-label translate>ITEMS.DETAILS.BARCODE</mat-label>
                                <input matInput formControlName="barcode">
                                @if(group.controls.barcode?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }

                                @if(isCameraBarcodeSupported) {
                                    <mat-icon 
                                        matIconSuffix
                                        #tooltip_orderName="matTooltip"
                                        class="tw-cursor-pointer tw-text-gray-500"
                                        [matTooltip]="'ITEMS.BARCODE_SCANNER' | translate"
                                        matTooltipPosition="above"
                                        (click)="openBarcodeAndSearch(i)" 
                                        aria-label="'ITEMS.BARCODE_SCANNER' | translate">
                                        photo_camera
                                    </mat-icon>
                                }
                            </mat-form-field>
                        </div>
        
                        <!-- Campo Quantità -->
                        <div class="tw-col-span-12 md:tw-col-span-3 tw-flex">
                            <div class="tw-w-[48px] md:tw-hidden"></div> 
                            
                            <mat-form-field class="tw-flex-1">
                                <mat-label translate>ITEMS.DETAILS.BARCODE_QTY</mat-label>
                                <input matInput type="number" formControlName="qty"
                                    [min]="1">
                                @if(group.controls.qty?.hasError('min')) {
                                    <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </section> 
                </div>
            }
        </div>
      </form>
  }
</tilby-dialog-content>